import { useEffect, useState } from 'react'

import useDebounce from './useDebounce'
import useFetchAPI from './useFetchAPI'

const SEARCH_URL = '/search/results'

const useSearchAPI = (props) => {
  const [value, setValue] = useState('')
  const [{ data }, setUrl] = useFetchAPI(null)
  const debouncedValue = useDebounce(value, 250)

  const handleBlur = () => {
    setValue('')
    setUrl(null)
  }

  const handleChange = (e) => {
    setValue(e.target.value)
  }

  useEffect(() => {
    if (debouncedValue.length < 3) {
      // Setting url to null will clear results by setting data to null (see useFetchAPI() for details)
      setUrl(null)
    } else {
      const querySearch = (value) => {
        setUrl(`${SEARCH_URL}?q=${value}`)
      }
      querySearch(debouncedValue)
    }
  }, [debouncedValue, setUrl])

  return {
    value,
    debouncedValue,
    data,
    handleBlur,
    handleChange
  }
}

export default useSearchAPI
